<template>
  <div
    v-if="menuOpened"
    class="fixed pin bg-white menu z-50"
  >
    <TheHeader
      with-close
      class="mb-1"
      @close="closeMenu"
    />
    <BaseSection>
      <BaseSectionHeader class="border-t border-strong-shadow-color py-4">
        {{ user.name }}
      </BaseSectionHeader>
      <BaseMenuList
        :items="menuItems"
        @itemClicked="closeMenu()"
      />
    </BaseSection>
    <BaseSection class="absolute bottom-anchor pin-x">
      <div
        class="border-t border-strong-shadow-color text-grey py-4"
        @click="logout"
      >
        {{ $t('Logout') }}
      </div>
    </BaseSection>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import TheHeader from './TheHeader.vue';
import BaseSection from './BaseSection.vue';
import BaseSectionHeader from './BaseSectionHeader.vue';
import BaseMenuList from './BaseMenuList.vue';
import { MENU_ITEMS } from '../constants';

export default {

  name: 'TheMenu',
  components: {
    TheHeader,
    BaseSection,
    BaseSectionHeader,
    BaseMenuList,
  },
  data() {
    return {
      menuItems: MENU_ITEMS,
    };
  },
  computed: {
    ...mapState({
      menuOpened: 'menuOpened',
      user: state => state.auth.user,
    }),
  },
  methods: {
    ...mapActions(['closeMenu']),
    ...mapActions('auth', ['logout']),
  },
};
</script>

<style lang="css" scoped>
.bottom-anchor {
  bottom: 100px;
}
</style>
